import React from 'react';
import { CVData, TemplateProps } from '../../types/cv';
import ModernBlueTemplate from './templates/ModernBlueTemplate';
import GeometricRedTemplate from './templates/GeometricRedTemplate';
import CreativeCrimsonTemplate from './templates/CreativeCrimsonTemplate';
import OceanWaveTemplate from './templates/OceanWaveTemplate';
import ProfessionalEdgeTemplate from './templates/ProfessionalEdgeTemplate';
import RedHexagonTemplate from './templates/RedHexagonTemplate';
import CorporateBlueTemplate from './templates/CorporateBlueTemplate';
import TealProfessionalTemplate from './templates/TealProfessionalTemplate';
import EarthTonesTemplate from './templates/EarthTonesTemplate';
import SkyBlueTemplate from './templates/SkyBlueTemplate';
import GoldenCurveTemplate from './templates/GoldenCurveTemplate';
import CrimsonWaveTemplate from './templates/CrimsonWaveTemplate';
import MagentaRibbonTemplate from './templates/MagentaRibbonTemplate';
import RedNavyTemplate from './templates/RedNavyTemplate';
import IvoirienElegantTemplate from './templates/IvoirienElegantTemplate';
import AbidjanCorporateTemplate from './templates/AbidjanCorporateTemplate';
import SahelModernTemplate from './templates/SahelModernTemplate';
import { hasUserStartedEditing } from '../../utils/cvPagination';
import { fontSizeCssVars } from '../../utils/cvFontSizes';

interface CVPreviewProps {
    data: CVData;
    template: string;
    isContinuationPage?: boolean;
    pageIndex?: number;
    totalPages?: number;
    fullData?: CVData;
}

const DEFAULT_TEMPLATE = 'ocean-wave';

const templates: Record<string, React.FC<TemplateProps>> = {
    'modern-blue': ModernBlueTemplate,
    'geometric-red': GeometricRedTemplate,
    'creative-crimson': CreativeCrimsonTemplate,
    'ocean-wave': OceanWaveTemplate,
    'professional-edge': ProfessionalEdgeTemplate,
    'red-hexagon': RedHexagonTemplate,
    'corporate-blue': CorporateBlueTemplate,
    'teal-professional': TealProfessionalTemplate,
    'earth-tones': EarthTonesTemplate,
    'sky-blue': SkyBlueTemplate,
    'golden-curve': GoldenCurveTemplate,
    'crimson-wave': CrimsonWaveTemplate,
    'magenta-ribbon': MagentaRibbonTemplate,
    'red-navy': RedNavyTemplate,
    'ivoirien-elegant': IvoirienElegantTemplate,
    'abidjan-corporate': AbidjanCorporateTemplate,
    'sahel-modern': SahelModernTemplate,
};

const CVPreview: React.FC<CVPreviewProps> = ({
    data,
    template,
    isContinuationPage = false,
    pageIndex = 0,
    fullData,
}) => {
    const SelectedTemplate = templates[template] || templates[DEFAULT_TEMPLATE];
    const showPlaceholders = !hasUserStartedEditing(fullData || data) && !isContinuationPage;

    return (
        <div style={{ width: '100%', height: '100%', ...fontSizeCssVars(data.style) }}>
            <SelectedTemplate
                data={data}
                isContinuationPage={isContinuationPage}
                showPlaceholders={showPlaceholders}
                pageIndex={pageIndex}
                fullData={fullData || data}
            />
        </div>
    );
};

export default CVPreview;
